export function HomeIcon() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="80"
        cy="80"
        r="80"
        fill="var(--landing-advantages-icon-bg, #E3D5BE)"
        fillOpacity="var(--landing-advantages-icon-bg-opacity, 0.24)"
      />
      <path
        d="M80 18C83.9233 18 87.727 19.1536 90.9824 21.333L125.183 44.1426C130.709 47.8128 134 53.9658 134 60.6104V107.986C134 117.907 125.921 125.986 116 125.986H44C34.079 125.986 26.0002 117.907 26 107.986V60.6104C26 53.9871 29.2908 47.813 34.8174 44.1426L69.0176 21.333C72.28 19.1534 76.0767 18 80 18ZM86.9893 27.3447C82.8127 24.5533 77.1941 24.5533 73.0176 27.3447L38.8184 50.1543C35.3098 52.4957 33.2002 56.398 33.2002 60.6309V108.007C33.2002 113.962 38.0446 118.807 44 118.807H116C121.955 118.807 126.8 113.962 126.8 108.007H126.807V60.6309C126.807 56.4193 124.698 52.4958 121.189 50.1543L86.9893 27.3447ZM90.0957 86.4775C91.0307 86.2808 91.9865 86.4782 92.7949 87.0195L92.8164 86.998C93.6108 87.5183 94.1658 88.3481 94.3486 89.2832C94.5244 90.2183 94.349 91.1889 93.8076 91.9834C90.8896 96.3777 85.996 98.9863 80.7227 98.9863H79.3018C74.0285 98.9862 69.1347 96.3777 66.2168 91.9834C65.6754 91.1889 65.493 90.2183 65.6758 89.2832C65.8586 88.3481 66.4004 87.5395 67.209 86.998C67.7856 86.6255 68.4884 86.4072 69.1914 86.4072C70.4008 86.4072 71.5332 87.0053 72.2012 88.0107C73.7902 90.387 76.4336 91.8075 79.2949 91.8076H80.7158C83.5774 91.8076 86.2285 90.3872 87.8105 88.0107C88.3308 87.2162 89.1395 86.6603 90.0957 86.4775ZM58.3994 68.4072C58.3994 63.6048 65.5986 63.6048 65.5986 68.4072C65.5984 73.2094 58.3996 73.2094 58.3994 68.4072ZM94.3994 68.4072C94.3994 63.6048 101.6 63.6048 101.6 68.4072C101.599 73.2094 94.3996 73.2094 94.3994 68.4072Z"
        fill="url(#paint0_linear_43_463)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_463"
          x1="80"
          y1="18"
          x2="80"
          y2="125.986"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--landing-advantages-icon-color-from, #FFA24B)" />
          <stop
            offset="1"
            stopColor="var(--landing-advantages-icon-color-to, #FF7B01)"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
